import { isBefore } from 'date-fns';
import { ValidatedCart } from '@water-web/types';

export const canCancelFromBookingInfo = (bookingInfo: ValidatedCart['bookingInfo'], now: Date): boolean => {
  if (!bookingInfo) return false;
  return !bookingInfo.canceled && !!bookingInfo.canCancelBefore && isBefore(now, new Date(bookingInfo.canCancelBefore));
};
